<div class="qr-generator-container">
    <qrcode [qrdata]="qrData" [width]="width" [errorCorrectionLevel]="level" [colorDark]="colorDark"
        [colorLight]="colorLight" [allowEmptyString]="allowEmptyString" [margin]="margin">
    </qrcode>

    @if (showActions) {
    <div class="qr-actions">
        <button mat-icon-button (click)="downloadQR()" matTooltip="Download QR Code">
            <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button (click)="printQR()" matTooltip="Print QR Code">
            <mat-icon>print</mat-icon>
        </button>
    </div>
    }
</div>